<script>
import baseMixins from '@/plans/ZOOM_MEETING/config/base';
import { mapGetters } from 'vuex';
import { get, includes } from 'lodash';
import { dateTimeFormat } from '@/utils/dateformat';
import { BILLING_CYCLE, ZOOM_MEETING_EDU_SCH_CMP_MIN_LICENSE, planTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';
import { getAssignedLicenseQuantity } from '@/plans/ZOOM_ONE_BUNDLE/utils'

export default {
  name: 'Escp2esc',
  mixins: [baseMixins],
  data() {
    return {
      showCategoryDesc: true,
      showPlanDetail: true,
    };
  },
  computed: {
    ...mapGetters([
      'boughtPlans',
      'basicConfig',
      'assignInfo',
      'disableMonthly2AnnualTip',
      'getUserCurrentSubscriptions',
      'limitLicenseWithBaseZoneTypes'
    ]),
    showExploreLink() {
      return true;
    },
    maxHost() {
      return 9999;
    },
    minHost() {
      return this.minHostAndReason.minHost;
    },
    isNormalCase() {
      return true;
    },
    couldBeRemovedAsAddonCard() {
      return false;
    },
    maxLicenseAddon() {
      return this.getUserCurrentSubscriptions
        .filter(item => includes(this.limitLicenseWithBaseZoneTypes, item.type))
        .reduce((maxPlan, plan) => {
          if (plan.cartInfo.selected_number > get(maxPlan, 'cartInfo.selected_number', 0)) {
            return plan;
          }
          return maxPlan;
        }, {});
    },
    boughtEduPlusPlans() {
      return plansof(this.boughtPlans).type(planTypes.ZONE_EDU_PLUS).get();
    },
    assignedEduPlusLicenseQuantity() {
      return getAssignedLicenseQuantity(this.boughtEduPlusPlans, this.assignInfo);
    },
    minHostAndReason() {
      let minHost = ZOOM_MEETING_EDU_SCH_CMP_MIN_LICENSE;
      const maxLicenseAddonLicense = get(this.maxLicenseAddon, 'cartInfo.selected_number', 0);
      // add-on
      if (this.form.selectedNumber <= maxLicenseAddonLicense) {
        const maxLicenseAddonTypeNameKey = this.maxLicenseAddon.typeNameKey;
        const maxLicenseAddonTypeName = this.$t(maxLicenseAddonTypeNameKey);
        return {
          reason: this.$t('billing.meeting_license_decrease_tips_need_decrease_addon', { product: maxLicenseAddonTypeName }),
          minHost: Math.max(maxLicenseAddonLicense, minHost)
        }
      }
      // assign info
      if (this.form.selectedNumber <= this.assignedEduPlusLicenseQuantity) {
        const needAssignTotalQuantity = this.assignedEduPlusLicenseQuantity - this.form.selectedNumber;
        const expireTime = this.boughtEduPlusPlans?.[0]?.cartInfo?.planExpireTime;
        if (needAssignTotalQuantity > 0) {
          return {
            minHost,
            reason: expireTime
            ? this.$t('billing.error.downgrade_alert_info', [needAssignTotalQuantity, dateTimeFormat(expireTime)])
            : this.$t('billing.error.downgrade_alert_info_no_date', [needAssignTotalQuantity])
          }
        }
      }
      return {
        reason: '',
        minHost
      }
    },
    licenseTips() {
      return this.minHostAndReason.reason;
    }
  },
  methods: {
    billingCycleDisabled({ billing_cycle }) {
      if (this.disableMonthly2AnnualTip && billing_cycle === BILLING_CYCLE.ANNUAL) {
        return this.disableMonthly2AnnualTip;
      }

      return this.getBillingCycleDisabledDesc(billing_cycle);
    },
  },
};
</script>
